import { render } from "./Reports.vue?vue&type=template&id=4755c0d6"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=4755c0d6&lang=css"
script.render = render

export default script